import {z} from 'zod';

/**
 * Zod transform that accepts a single string or an array of strings and splits
 * on comma, returning a flattened array. Handles both `?x=a,b` and `?x=a&x=b`.
 */
export const multiString = z
  .union([z.string(), z.array(z.string())])
  .optional()
  .transform((val) => {
    if (!val) {
      return undefined;
    }
    if (Array.isArray(val)) {
      return val.flatMap((v) => v.split(','));
    }
    return val.split(',');
  });
